<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'prodaggregs.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="prodaggregsGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:preload="preload" v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'

export default {
  name: 'UsersGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      url: 'prodaggregs',
      preload: [{
        field: 'brand_id',
        api: 'brands/lst'
      }, {
        field: 'division_id',
        api: 'divisions/lst'
      }, {
        field: 'top10_id',
        api: 'top10/lst'
      }, {
        field: 'product_category_id',
        api: 'categories/lst'
      }, {
        field: 'subsector_id',
        api: 'subsectors/lst'
      }, {
        field: 'variety_id',
        api: 'varieties/lst'
      }, {
        field: 'shopping_group_id',
        api: 'shoppinggroups/lst'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '120px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'code',
        title: 'Código',
        width: '120px'
      },
      {
        field: 'brand_id',
        title: 'Marca',
        values: [],
        type: 'number',
        width: '180px'
      },
      {
        field: 'division_id',
        title: 'Divisão',
        values: [],
        type: 'number',
        width: '180px'
      },
      {
        field: 'top10_id',
        title: 'Top 10',
        values: [],
        type: 'number',
        width: '180px'
      },
      {
        field: 'product_category_id',
        title: 'Categoria',
        values: [],
        type: 'number',
        width: '180px'
      },
      {
        field: 'subsector_id',
        title: 'Sub-sector',
        values: [],
        type: 'number',
        width: '180px'
      },
      {
        field: 'variety_id',
        title: 'Variedade',
        values: [],
        type: 'number',
        width: '180px'
      },
      {
        field: 'shopping_group_id',
        title: 'Shopping Group',
        values: [],
        type: 'number',
        width: '180px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'prodaggregs.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('prodaggregs.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
